import React from "react";
import Seo from "/src/components/Seo";
import Layout from "/src/_v2/layouts/LayoutTW";

import {graphql} from "gatsby";

import {IntroSection} from "/src/_v2/templates/MergedMining/components/IntroSection";
import {AdvantagesSection} from "/src/_v2/templates/MergedMining/components/AdvantagesSection";
import {StepsSection} from "/src/_v2/templates/MergedMining/components/StepsSection";
import {EarnSection} from "/src/_v2/templates/MergedMining/components/EarnSection";
import {LeadershipSection} from "/src/_v2/templates/MergedMining/components/LeadershipSection";

import {SubscribeSection} from "/src/_v2/ui/sections/SubscribeSection";

import {FAQSection} from "/src/_v2/templates/Powpeg/components/FAQSection";
import {MembersSection} from "/src/_v2/templates/Powpeg/components/MembersSection";


const MiningPage = (props) => {
  const acf = props.data.page.template.miningRDPageACF || {};

  const translations = props?.data?.page?.translations || {}

  return (
    <Layout translations={translations}>
      <IntroSection data={acf.intro}/>
      <AdvantagesSection data={acf.advantages}/>
      <MembersSection data={acf.tools} suptitleColor="lime"/>
      <StepsSection data={acf.start} suptitleColor="cyan"/>
      <EarnSection data={acf.earn}/>
      <LeadershipSection data={acf.believe}/>
      <FAQSection data={acf.faq}/>
      <SubscribeSection index={'08.'}/>
    </Layout>
  );
};

export default MiningPage;
export const pageQuery = graphql`
  query ($lng: String!, $id: Int!) {
    locales: allLocale(
      filter: { language: { eq: $lng } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    page : wpPage(language: {slug: {eq: $lng}}, databaseId: { eq: $id }) {
      translations {
        slug
      }
      seo {
        metaDesc
        opengraphDescription
        opengraphTitle
        title
      }
      template {
        ... on WpTemplate_MergedMiningRD {
          miningRDPageACF {
            advantages {
              number
              suptitle:subtitle
              title
              items {
                color
                text
                title
              }
            }
            intro {
              number
              text
              titlePart1
              titlePart2
              titlePart3
              link {
                target
                title
                url
              }
            }
            start {
              number
              suptitle:subtitle
              title
              text
              items {
                color
                text
                title
                index
              }
            }
            tools {
              number
              suptitle:subtitle
              title
              text:description
              items {
                link {
                  target
                  title
                  url
                }
                logo {
                  localFile {
                    publicURL
                  }
                  altText
                  width
                  height
                }
              }
            }
            earn {
              table {
                columns {
                  col1
                  col2
                  col3
                  col4
                  col5
                  col6
                  col7
                }
                rows {
                  col1
                  col2
                  col3
                  col4
                  col5
                  col6
                  col7
                }
              }
              number
              suptitle:subtitle
              textLeft
              textRight
              title
              text
            }
            faq {
              number
              suptitle:subtitle
              title
              items {
                text
                title
              }
            }
            believe {
              number
              suptitle:subtitle
              title
              text
              button {
                target
                title
                url
              }
              items {
                color
                text
                title
              }
            }
          }
        }
      }
    }
  }
`;
export const Head = (props) => {
  const seo = props.data.page?.seo || {}
  return <Seo title={seo?.title} description={seo?.metaDesc} />;
}
